import { render, staticRenderFns } from "./PagePreviewImage.vue?vue&type=template&id=e0dc58ea"
import script from "./PagePreviewImage.vue?vue&type=script&lang=js"
export * from "./PagePreviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports